import React from 'react';
import { motion } from 'framer-motion';

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1
  }
};

const Education: React.FC = () => {
  return (
    
    <div className="px-4 md:px-8 bg-black pb-24"> 
      <div className="max-w-2xl md:max-w-7xl mx-auto">
        
        {/* Sight line separator */}
        <div className="border-t border-white/20 my-20"></div>
        <motion.div className="flex flex-col md:flex-row md:justify-between md:items-start">
          <h2 className="text-lg font-bold">Educations</h2>
          <motion.h4 
            className="text-base font-normal leading-relaxed md:text-base md:leading-relaxed md:max-w-4xl text-white opacity-[60%] md:ml-auto"
            variants={itemVariants}
          >
            I hold a Master’s degree in Advanced Computer Science from The British College, affiliated with Keele University, where I focused on cloud computing, web technologies, system design, and user interaction design. My postgraduate research project explored the use of deep neural networks, transformers, and K-nearest neighbors (KNN) in deep embeddings for plant recognition. <br>
            </br><br>
            </br>Prior to that, I completed my Bachelor’s in Computer Science from Herald College, under the University of Wolverhampton, where I developed a strong foundation in artificial intelligence, machine learning, cloud systems, and human-computer interaction. <br>
            </br><br></br>My academic journey began at Chanakya College of Management, where I pursued +2 in Management with Computer Science, alongside studies in mathematics, economics, and accountancy.
          
          </motion.h4>
        </motion.div>
      </div>
    </div>
    
    
  );
};

export default Education;